import { useSplunkCallback } from 'hooks/use-splunk-callback/use-splunk-callback';
import { useCallback } from 'react';
import { EventData } from 'types/splunk/events';

type ISupportSplunkEvent = EventData & {
    load_time?: number;
};

const defaultEventData = {
    view_name: 'Support Requests',
};

const convertMsToSeconds = (ms: number) => Math.round((ms / 1000) * 100) / 100;

export const useSendSupportSplunkEvent = () => {
    const sendSplunkEvent = useSplunkCallback<ISupportSplunkEvent>();

    return useCallback(
        (data: ISupportSplunkEvent) =>
            sendSplunkEvent({
                ...defaultEventData,
                ...data,
                ...(data.load_time ? { load_time: convertMsToSeconds(data.load_time) } : {}),
            }),
        [sendSplunkEvent],
    );
};
